module.exports = __webpack_public_path__ + "static/media/ck.e5175516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ck.png
// module id = 1819
// module chunks = 0